import React from 'react';

const PROGRAM_LABELS = {
  praktikum: 'Praktikum',
  msib: 'MSIB',
  mandiri: 'Mandiri',
  volunteer: 'Volunteer',
  bumdes: 'BUMDes',
};

const ConversionFunnelCard = ({ data, loading, availability }) => {
  return (
    <div className="card border-0 shadow-sm rounded-4 overflow-hidden h-100 management-card-v2">
      <div className="card-body p-3">
        <h6 className="fw-bold mb-3 text-dark" style={{ fontSize: '0.9rem' }}>
          <i className="bi bi-funnel-fill me-2 text-primary"></i>
          Funnel Konversi per Program
        </h6>

        {loading ? (
          <div className="py-2 text-center">
            <div className="spinner-border spinner-border-sm text-light" />
          </div>
        ) : (
          <div className="row row-cols-2 row-cols-md-3 row-cols-xl-5 g-2">
            {Object.entries(PROGRAM_LABELS).map(([key, label]) => {
              const isUnavailable = availability && !availability[key];
              const funnel = data?.[key];
              const reg = funnel?.REG || 0;
              const active = funnel?.ACTIVE_PROGRAM || 0;
              const rejected = funnel?.REJECTED || 0;
              const resigned = funnel?.RESIGNED || 0;
              const conversionRate = funnel?.conversionRate || 0;

              return (
                <div className="col" key={key}>
                  <div className={`p-2 rounded-3 bg-light h-100 ${isUnavailable ? 'opacity-50' : ''}`}>
                    <div className="extra-small fw-bold text-uppercase text-muted mb-1">{label}</div>
                    {isUnavailable ? (
                      <div className="text-muted extra-small py-2 text-center">N/A pada periode ini</div>
                    ) : (
                      <>
                        <div className="d-flex justify-content-between align-items-baseline mb-1">
                          <span className="fw-black h6 mb-0">{reg}</span>
                          <span className="extra-small fw-bold text-success">{conversionRate}% diterima</span>
                        </div>
                        <div className="progress rounded-pill mb-1" style={{ height: '4px' }}>
                          <div
                            className="progress-bar bg-success"
                            style={{ width: `${reg > 0 ? (active / reg) * 100 : 0}%` }}
                          ></div>
                        </div>
                        <div className="d-flex justify-content-between extra-small text-muted">
                          <span>Diterima: {active}</span>
                          <span>Ditolak: {rejected}</span>
                          <span>Resign: {resigned}</span>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
      <style>{`
        .extra-small { font-size: 0.6rem; letter-spacing: 0.5px; }
        .fw-black { font-weight: 800; }
        .management-card-v2 { border: 1px solid #f0f0f0 !important; }
      `}</style>
    </div>
  );
};

export default ConversionFunnelCard;
